import { useCallback, useState } from 'react';

export const useCarousel = <T>(items: T[]) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const goToSlide = useCallback((index: number) => {
    setCurrentSlide(index);
  }, []);

  const nextSlide = useCallback(() => {
    setCurrentSlide((currentSlideIndex) => {
      const nextSlideIndex = currentSlideIndex + 1;
      const isLastSlide = nextSlideIndex >= items.length;
      return isLastSlide ? 0 : nextSlideIndex;
    });
  }, [items.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => {
      if (prev === 0) {
        return items.length - 1;
      }
      return prev - 1;
    });
  }, [items.length]);

  const currentItem = items[currentSlide];

  return {
    currentSlide,
    currentItem,
    goToSlide,
    nextSlide,
    prevSlide,
  };
};
